import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'

const routes = [
  {
    path: '/',
    name: 'main',
    meta: { layout: 'main', requiresAuth: true },
    component: () => import('@/views/health/main-pages/ProfilePage'),
  },
  {
    path: '/terms-of-service',
    name: 'terms-of-service',
    meta: { layout: 'tos' },
    component: () => import('@/views/health/main-pages/TermsOfService'),
  },
  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    meta: { layout: 'tos' },
    component: () => import('@/views/health/main-pages/PrivacyPolicy'),
  },
  {
    path: '/profile',
    name: 'profile',
    meta: { layout: 'main', requiresAuth: true },
    component: () => import('@/views/health/main-pages/ProfilePage'),
  },
  {
    path: '/disciplines',
    name: 'disciplines',
    meta: { layout: 'main', requiresAuth: true },
    component: () => import('@/views/health/main-pages/DisciplinesPage'),
  },
  {
    path: '/chats',
    name: 'chats',
    meta: { layout: 'main', requiresAuth: true },
    component: () => import('@/views/health/main-pages/ChatsPage'),
  },
  {
    path: '/users',
    name: 'users',
    meta: { layout: 'main', requiresAuth: true },
    component: () => import('@/views/health/main-pages/UsersPage'),
  },
  {
    path: '/visits',
    name: 'visits',
    meta: { layout: 'main', requiresAuth: true },
    component: () => import('@/views/health/main-pages/visits/VisitsPageHA'),
  },
  {
    path: '/visits/new-offer',
    name: 'visits.new-offer',
    component: () => import('@/views/health/main-pages/visits/NewOfferPage/'),
    meta: { layout: 'main', requiresAuth: true },
  },
  {
    path: '/visits/edit-offer/:offerId',
    name: 'visits.edit-offer',
    component: () => import('@/views/health/main-pages/visits/NewOfferPage/'),
    meta: { layout: 'main', requiresAuth: true },
  },
  {
    path: '/patients',
    name: 'patients',
    meta: { layout: 'main', requiresAuth: true },
    component: () => import('@/views/health/main-pages/patients/PatientsPage'),
  },
  {
    path: '/patients/new',
    name: 'patients.new',
    meta: { layout: 'main', requiresAuth: true },
    component: () =>
      import('@/views/health/main-pages/patients/NewPatientPage'),
  },
  {
    path: '/patients/edit/:uuid',
    name: 'patients.edit',
    meta: { layout: 'main', requiresAuth: true },
    component: () =>
      import('@/views/health/main-pages/patients/NewPatientPage'),
  },
  {
    path: '/patients/:uuid/offers/new',
    name: 'patients.offers.new',
    component: () => import('@/views/health/main-pages/visits/NewOfferPage/'),
    meta: { layout: 'main', requiresAuth: true },
  },
  {
    path: '/patients/:uuid',
    name: 'patient-details',
    meta: { layout: 'main', requiresAuth: true },
    component: () =>
      import('@/views/health/main-pages/patients/PatientDetailsPage'),
  },
  {
    path: '/login',
    name: 'login',
    meta: { layout: 'health-auth' },
    component: () => import('../views/health/auth/SignInForm'),
  },
  {
    path: '/register',
    name: 'register',
    meta: { layout: 'health-auth' },
    component: () => import('../views/health/auth/SignUpForm'),
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    meta: { layout: 'health-auth' },
    component: () => import('../views/health/auth/ForgotPassForm'),
  },
  {
    path: '/change-password',
    name: 'change-password',
    meta: { layout: 'health-auth' },
    component: () => import('../views/health/auth/ResetPassForm'),
  },
  {
    path: '/set-password',
    name: 'set-password',
    meta: { layout: 'health-auth' },
    component: () => import('../views/health/auth/ResetPassForm'),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

router.beforeEach((to, from, next) => {
  const loggedIn = store.state.auth.status.loggedIn

  if (to.matched.some((record) => record.meta.requiresAuth) && !loggedIn) {
    next({ name: 'login' })
  } else if (to.path == '/') {
    next({ name: 'profile' })
  } else {
    next()
  }
})

export default router
